import styled from '@emotion/styled';

import { tokens } from '@hotjar/hotsauce';

export const FeatureBarStyles = {
  Illustration: styled.img`
    display: block;
    height: 190px;
    object-fit: contain;
    width: 336px;
  `,
  ContentContainer: styled.div`
    align-items: flex-start;
    display: flex;
    flex-direction: column;
    justify-content: center;
  `,
  FeatureTitle: styled.span`
    display: block;

    ${tokens.text('header5')};
  `,
  FeatureDescription: styled.span`
    display: block;
    margin-top: ${tokens.spacer.x0};
    max-width: 450px;
    white-space: pre-line;
    width: 100%;

    ${tokens.text('body2')};
  `,
  FeaturePlanListLabel: styled.span`
    ${tokens.text('caption')};
  `,
  ListItem: styled.li`
    margin-left: ${tokens.spacer.x1};
  `,
};
